import { ATLAS_ASSET_TOKEN_LOCAL_STORAGE_KEY } from "@/modules/atlas-asset-token/constants";
import { AtlasAssetTokenInfo } from "@/modules/atlas-asset-token/types";
import localforage from "localforage";

export const setAtlasAssetToken = async ({
  info,
}: {
  info: AtlasAssetTokenInfo;
}): Promise<void> => {
  await localforage.setItem(ATLAS_ASSET_TOKEN_LOCAL_STORAGE_KEY, info);
};
